import { computed, ComputedRef } from "vue"
import store from "@/vue/planning/store/store"
import flightPackCode from "@/config/flightPackCode"
import { airportCodeMap } from "@/config/airportCodeMap"
import trainPackCode from "@/config/trainPackCode"
import { trainStationCodeMap } from "@/config/trainStationCodeMap"
import type { WiypResponse } from "@/types/responses"

// Resolves the origin (airport / train station code) the same way getWiypPrice does,
// based on the current packCode and the user's selected origin.
const resolveOrigin = (): string => {
	const packCode: string = store.state.packCode
	if (!packCode) return "NA"

	const rawOrigin: string =
		store.state.flightOrigin ?? store.state.wiypDefaultFlightOrigin ?? ""

	if (flightPackCode.includes(packCode)) {
		return airportCodeMap.has(rawOrigin)
			? rawOrigin
			: Array.from(airportCodeMap.keys())[0] || "NA"
	}

	if (trainPackCode.includes(packCode)) {
		return trainStationCodeMap.has(rawOrigin)
			? rawOrigin
			: Array.from(trainStationCodeMap.keys())[0] || "NA"
	}

	return "NA"
}

// Returns a lookup function for the WiyP response of a given packageId.
// The closure is rebuilt only when familyComposition / origin / packageCode change,
// so callers can invoke `getWiypData.value(prestId)` cheaply.
const getWiypData: ComputedRef<(packageId: string) => WiypResponse | undefined> = computed(() => {
	const familyComposition = store.state.participants.join("-")
	const packageCode = store.state.packCode
	const origin = resolveOrigin()

	return (packageId: string): WiypResponse | undefined => {
		if (!packageId) return undefined

		return store.getters.getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId(
			familyComposition,
			origin,
			packageCode,
			packageId
		)
	}
})

export default getWiypData
